import { createFileRoute, redirect, notFound } from "@tanstack/react-router";
import { useParams, Navigate } from "@/lib/router-compat";
import LearnPageLayoutEs from "@/components/LearnPageLayoutEs";
import { InlineEligibilityForm } from "@/components/InlineEligibilityForm";
import { esPageWhenAntidepressantsDontWork } from "@/pages/learn/es/learnDataEsWhenAntidepressants";
import { esWhatIsSaintTms } from "@/pages/learn/es/learnDataEsWhatIsSaint";
import { esWhatToExpect } from "@/pages/learn/es/learnDataEsWhatToExpect";
import { esHowFast } from "@/pages/learn/es/learnDataEsHowFast";
import { esFmriGuided } from "@/pages/learn/es/learnDataEsFmri";
import { esFiveDay } from "@/pages/learn/es/learnDataEsFiveDay";
import { esWithoutMedication } from "@/pages/learn/es/learnDataEsWithoutMedication";
import { esWithoutMoreMedication } from "@/pages/learn/es/learnDataEsWithoutMoreMedication";
import { esFastTrd } from "@/pages/learn/es/learnDataEsFastTrd";
import { esTmsForAnxietyOcdPtsd } from "@/pages/learn/es/learnDataEsTmsForAnxietyOcdPtsd";
import { esWhatIsTmsTherapy } from "@/pages/learn/es/learnDataEsWhatIsTmsTherapy";
import { esWhatIsTrd } from "@/pages/learn/es/learnDataEsWhatIsTrd";
import { esTmsDevices } from "@/pages/learn/es/learnDataEsTmsDevices";
import { esSpravatoVsTms } from "@/pages/learn/es/learnDataEsSpravatoVsTms";
import { esSaintVsTraditional } from "@/pages/learn/es/learnDataEsSaintVsTraditional";
import { esSaintCoralSprings } from "@/pages/learn/es/learnDataEsCoralSprings";
import { esSaintEastCoast } from "@/pages/learn/es/learnDataEsEastCoast";
import { esSaintNearMe } from "@/pages/learn/es/learnDataEsNearMe";
import { esSaintVsKetamine } from "@/pages/learn/es/learnDataEsVsKetamine";
import { esSaintVsSpravato } from "@/pages/learn/es/learnDataEsVsSpravato";
import { esSaintTmsCost } from "@/pages/learn/es/learnDataEsCost";
import { esDoesInsuranceCover } from "@/pages/learn/es/learnDataEsInsurance";
import { esWhereCanIGet } from "@/pages/learn/es/learnDataEsWhere";
import { esHowDoesSaintWork } from "@/pages/learn/es/learnDataEsHowDoesSaintWork";
import { esHowLongTake } from "@/pages/learn/es/learnDataEsHowLongTake";
import { esSignsOfTrd } from "@/pages/learn/es/learnDataEsSignsOfTrd";
import { esNewTreatmentsTrd } from "@/pages/learn/es/learnDataEsNewTreatmentsTrd";
import { esAlternativeAntidepressants } from "@/pages/learn/es/learnDataEsAlternativeAntidepressants";
import { esWhyAntidepressantNotWorking } from "@/pages/learn/es/learnDataEsWhyNotWorking";
import { esBeyondMedication } from "@/pages/learn/es/learnDataEsBeyondMedication";
import { esAcceleratedThetaBurst } from "@/pages/learn/es/learnDataEsAcceleratedVsConventional";
import { esAcceleratedVsConventional } from "@/pages/learn/es/learnDataEsAcceleratedVsConventionalHub";
import { esSaintVsAccelerated } from "@/pages/learn/es/learnDataEsSaintVsAccelerated";
import { esSaintVsAntidepressants } from "@/pages/learn/es/learnDataEsSaintVsAntidepressants";
import { esSaintVsEct } from "@/pages/learn/es/learnDataEsSaintVsEct";
import { esTmsVsMedication } from "@/pages/learn/es/learnDataEsTmsVsMedication";
import { esTmsVsMedicationForDepression } from "@/pages/learn/es/learnDataEsTmsVsMedicationForDepression";
import { esTmsVsSpravato } from "@/pages/learn/es/learnDataEsTmsVsSpravato";
import { esWhatComesAfter } from "@/pages/learn/es/learnDataEsWhatComesAfter";
import { esOptionsWhenNothingWorks } from "@/pages/learn/es/learnDataEsOptionsWhenNothingWorks";
import { esBrainTarget } from "@/pages/learn/es/learnDataEsBrainTarget";
import { esBetweenSessions } from "@/pages/learn/es/learnDataEsBetweenSessions";
import { esTwoAntidepressantsDontWork } from "@/pages/learn/es/learnDataEsTwoAntidepressants";
import { esHowManyAntidepressants } from "@/pages/learn/es/learnDataEsHowManyAntidepressants";
import { esHowManySessions } from "@/pages/learn/es/learnDataEsHowManySessions";
import { esHowQuicklyStart } from "@/pages/learn/es/learnDataEsHowQuicklyStart";
import { esHowFastVsTms } from "@/pages/learn/es/learnDataEsHowFastVsTms";
import { esDoesSaintRequireMri } from "@/pages/learn/es/learnDataEsRequiresMri";
import { esDoesSaintRequireAnesthesia } from "@/pages/learn/es/learnDataEsRequiresAnesthesia";
import { esSideEffects } from "@/pages/learn/es/learnDataEsSideEffects";
import { esWhatDoesItFeelLike } from "@/pages/learn/es/learnDataEsWhatDoesItFeelLike";
import { esWhatHappensAfter } from "@/pages/learn/es/learnDataEsWhatHappensAfter";
import { esCanDriveAndWork } from "@/pages/learn/es/learnDataEsCanDriveWork";
import { esOutpatientOrHospital } from "@/pages/learn/es/learnDataEsOutpatientHospital";
import { esWhoQualifies } from "@/pages/learn/es/learnDataEsWhoQualifies";
import { esSaintForTrd } from "@/pages/learn/es/learnDataEsSaintForTrd";
import { esSaintAfterMedFailure } from "@/pages/learn/es/learnDataEsSaintAfterMedFailure";
import { esWhatIsSaintTreatment } from "@/pages/learn/es/learnDataEsWhatIsSaintTreatment";
import { esOutpatientSaint } from "@/pages/learn/es/learnDataEsOutpatientSaint";
import { esRequiresAnesthesiaOrMedication } from "@/pages/learn/es/learnDataEsRequiresAnesthesiaOrMedication";
import { esCanWorkDuringWeek } from "@/pages/learn/es/learnDataEsCanWorkDuringWeek";
import { esCanSomeoneTravel } from "@/pages/learn/es/learnDataEsCanSomeoneTravel";
import { esAlwaysTiredFatigue } from "@/pages/learn/es/learnDataEsAlwaysTiredFatigue";
import { esDepressionPhysicalPain } from "@/pages/learn/es/learnDataEsDepressionPhysicalPain";
import { esAnxietyChestTightness } from "@/pages/learn/es/learnDataEsAnxietyChestTightness";
import { esCantStopCrying } from "@/pages/learn/es/learnDataEsCantStopCrying";
import { esAnxietyWorseMorning } from "@/pages/learn/es/learnDataEsAnxietyWorseMorning";
// Batch N: remaining English learn slugs → Spanish
import { esAdvancedDepressionTreatment } from "@/pages/learn/es/learnDataEsAdvancedDepressionTreatment";
import { esStillDepressedOnMedication } from "@/pages/learn/es/learnDataEsStillDepressedOnMedication";
import { esAlternativeToEct } from "@/pages/learn/es/learnDataEsAlternativeToEct";
import { esDepressionResistantToMedication } from "@/pages/learn/es/learnDataEsDepressionResistantToMedication";
import { esCanSaintHelpAfterMeds } from "@/pages/learn/es/learnDataEsCanSaintHelpAfterMeds";
import { esCanTmsHelpAfterAntidepressants } from "@/pages/learn/es/learnDataEsCanTmsHelpAfterAntidepressants";
import {
  esNothingWorksForDepression,
  esLostHope,
  esDepressionKeepsComingBack,
  esDepressedForYears,
  esDontWantToChangeAntidepressants,
  esOptionsIfTherapyDoesntHelp,
  esDepressionImpossibleToTreat,
} from "@/pages/learn/es/learnDataEsEmotionalSearches";
import { esDepressionWontGoAway } from "@/pages/learn/es/learnDataEsDepressionWontGoAway";
import { esNoMoreMedication } from "@/pages/learn/es/learnDataEsNoMoreMedication";
import {
  esFastDepressionTreatment,
  esFastestTreatment,
} from "@/pages/learn/es/learnDataEsFastDepressionTreatment";
import { esHighFunctioningDepression } from "@/pages/learn/es/learnDataEsHighFunctioningDepression";
import {
  esHowToFindLegitimateSaintProvider,
  esWhatToLookForInDepressionCenter,
} from "@/pages/learn/es/learnDataEsProviderQuestions";
import {
  esHowToFindSaintProvider,
  esIsSaintAvailableNearMe,
} from "@/pages/learn/es/learnDataEsHowToFindSaintProvider";
import { esIsSaintCoveredByInsurance } from "@/pages/learn/es/learnDataEsIsSaintCoveredByInsurance";
import {
  esQuestionsToAskProvider,
  esWhatIsVerifiedProvider,
  esWhereCanIGetSaintTreatment,
} from "@/pages/learn/es/learnDataEsQuestionsToAskProvider";
import { esSaintTmsResults } from "@/pages/learn/es/learnDataEsSaintTmsResults";
import { esCognitiveFxVsSaint } from "@/pages/learn/es/learnDataEsCognitiveFxVsSaint";
import { esAmpaTmsCost } from "@/pages/learn/es/learnDataEsAmpaTmsCost";
import { esAmpaOneVsNeurostarVsBrainsway } from "@/pages/learn/es/learnDataEsAmpaOneVsNeurostarVsBrainsway";
import { esSaintVsAmpaOne } from "@/pages/learn/es/learnDataEsSaintVsAmpaOne";
import { esAmpaTmsReviewsWhatToExpect } from "@/pages/learn/es/learnDataEsAmpaTmsReviewsWhatToExpect";
import { esAmpaTmsFlorida } from "@/pages/learn/es/learnDataEsAmpaTmsFlorida";
import { esCameraGuidedPortableTms } from "@/pages/learn/es/learnDataEsCameraGuidedPortableTms";
import { esAmpaReceptorsKetamineAndTms } from "@/pages/learn/es/learnDataEsAmpaReceptorsKetamineAndTms";
import { esSaintDisclaimer } from "@/pages/learn/es/learnDataEsSaintDisclaimer";
import { esBeamF3VsFmri } from "@/pages/learn/es/learnDataEsBeamF3VsFmri";
import { esSaintProsAndCons } from "@/pages/learn/es/learnDataEsSaintProsAndCons";
import { esLocalVsTravelFiveDay } from "@/pages/learn/es/learnDataEsLocalVsTravelFiveDay";
import { esSaintTmsUtah } from "@/pages/learn/es/learnDataEsSaintTmsUtah";
import { esSaintTmsNevada } from "@/pages/learn/es/learnDataEsSaintTmsNevada";
import { esSaintTmsColorado } from "@/pages/learn/es/learnDataEsSaintTmsColorado";
import { esSaintAgeRequirements } from "@/pages/learn/es/learnDataEsSaintAgeRequirements";
import {
  esSaintBocaRaton,
  esSaintFortLauderdale,
  esSaintMiami,
  esSaintFlorida,
  esSaintTmsLocations,
} from "@/pages/learn/es/learnDataEsSaintLocations";
import { esBcbsSaint } from "@/pages/learn/es/learnDataEsBcbsSaint";
import {
  esSaintCostHub,
  esSaintCostInsuranceCoverage,
} from "@/pages/learn/es/learnDataEsSaintCostHub";
import {
  esSaintTmsProtocol,
  esSaintQuestions,
  esSaintWeekDayByDay,
  esStanfordAcceleratedIntelligentNeuromodulationTherapy,
  esTravelForSaint,
  esTherapyNotHelping,
  esTmsAfterAntidepressantsFail,
  esTiredOfFeelingDepressed,
  esTiredOfFeelingDepressedOptionsLeft,
  esWhyDoesMyDepressionKeepComingBack,
} from "@/pages/learn/es/learnDataEsSaintProtocolEtc";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";
import type { LearnPageData } from "@/pages/learn/learnShared";

import { esAcceleratedTmsCost } from "@/pages/learn/es/learnDataEsAcceleratedTmsCost";
import { esAcceleratedTmsNearMe } from "@/pages/learn/es/learnDataEsAcceleratedTmsNearMe";
import { esCanSaintMakeDepressionWorse } from "@/pages/learn/es/learnDataEsCanSaintMakeDepressionWorse";
import { esCognitiveFxAlternative } from "@/pages/learn/es/learnDataEsCognitiveFxAlternative";
import { esSaintCoralGables } from "@/pages/learn/es/learnDataEsSaintCoralGables";
import { esSaintTmsSuccessRates } from "@/pages/learn/es/learnDataEsSaintTmsSuccessRates";
import { esSaintVsMert } from "@/pages/learn/es/learnDataEsSaintVsMert";
import { esSaintVsOneDayTms } from "@/pages/learn/es/learnDataEsSaintVsOneDayTms";
import { esSaintVsDeepTms } from "@/pages/learn/es/learnDataEsSaintVsDeepTms";

const esPages: LearnPageData[] = [
  esPageWhenAntidepressantsDontWork,
  esWhatIsSaintTms,
  esWhatToExpect,
  esHowFast,
  esFmriGuided,
  esFiveDay,
  esWithoutMedication,
  esWithoutMoreMedication,
  esFastTrd,
  esTmsForAnxietyOcdPtsd,
  esWhatIsTmsTherapy,
  esWhatIsTrd,
  esTmsDevices,
  esSpravatoVsTms,
  esSaintVsTraditional,
  esSaintCoralSprings,
  esSaintEastCoast,
  esSaintNearMe,
  esSaintVsKetamine,
  esSaintVsSpravato,
  esSaintTmsCost,
  esDoesInsuranceCover,
  esWhereCanIGet,
  esHowDoesSaintWork,
  esHowLongTake,
  esSignsOfTrd,
  esNewTreatmentsTrd,
  esAlternativeAntidepressants,
  esWhyAntidepressantNotWorking,
  esBeyondMedication,
  esAcceleratedThetaBurst,
  esAcceleratedVsConventional,
  esSaintVsAccelerated,
  esSaintVsAntidepressants,
  esSaintVsEct,
  esTmsVsMedication,
  esTmsVsMedicationForDepression,
  esTmsVsSpravato,
  esWhatComesAfter,
  esOptionsWhenNothingWorks,
  esBrainTarget,
  esBetweenSessions,
  esTwoAntidepressantsDontWork,
  esHowManyAntidepressants,
  esHowManySessions,
  esHowQuicklyStart,
  esHowFastVsTms,
  esDoesSaintRequireMri,
  esDoesSaintRequireAnesthesia,
  esSideEffects,
  esWhatDoesItFeelLike,
  esWhatHappensAfter,
  esCanDriveAndWork,
  esOutpatientOrHospital,
  esWhoQualifies,
  esSaintForTrd,
  esSaintAfterMedFailure,
  esWhatIsSaintTreatment,
  esOutpatientSaint,
  esRequiresAnesthesiaOrMedication,
  esCanWorkDuringWeek,
  esCanSomeoneTravel,
  esAlwaysTiredFatigue,
  esDepressionPhysicalPain,
  esAnxietyChestTightness,
  esCantStopCrying,
  esAnxietyWorseMorning,
  // Batch N: remaining English learn slugs → Spanish
  esAdvancedDepressionTreatment,
  esStillDepressedOnMedication,
  esAlternativeToEct,
  esDepressionResistantToMedication,
  esCanSaintHelpAfterMeds,
  esCanTmsHelpAfterAntidepressants,
  esNothingWorksForDepression,
  esLostHope,
  esDepressionKeepsComingBack,
  esDepressedForYears,
  esDontWantToChangeAntidepressants,
  esOptionsIfTherapyDoesntHelp,
  esDepressionImpossibleToTreat,
  esDepressionWontGoAway,
  esNoMoreMedication,
  esFastDepressionTreatment,
  esFastestTreatment,
  esHighFunctioningDepression,
  esHowToFindLegitimateSaintProvider,
  esWhatToLookForInDepressionCenter,
  esHowToFindSaintProvider,
  esIsSaintAvailableNearMe,
  esIsSaintCoveredByInsurance,
  esQuestionsToAskProvider,
  esWhatIsVerifiedProvider,
  esWhereCanIGetSaintTreatment,
  esSaintBocaRaton,
  esSaintFortLauderdale,
  esSaintMiami,
  esSaintFlorida,
  esSaintTmsLocations,
  esBcbsSaint,
  esSaintCostHub,
  esSaintCostInsuranceCoverage,
  esSaintTmsProtocol,
  esSaintQuestions,
  esSaintWeekDayByDay,
  esStanfordAcceleratedIntelligentNeuromodulationTherapy,
  esTravelForSaint,
  esTherapyNotHelping,
  esTmsAfterAntidepressantsFail,
  esTiredOfFeelingDepressed,
  esTiredOfFeelingDepressedOptionsLeft,
  esWhyDoesMyDepressionKeepComingBack,
  esSaintTmsResults,
  esCognitiveFxVsSaint,
  esAmpaTmsCost,
  esAmpaOneVsNeurostarVsBrainsway,
  esSaintVsAmpaOne,
  esAmpaTmsReviewsWhatToExpect,
  esAmpaTmsFlorida,
  esCameraGuidedPortableTms,
  esAmpaReceptorsKetamineAndTms,
  esSaintDisclaimer,
  esBeamF3VsFmri,
  esSaintProsAndCons,
  esLocalVsTravelFiveDay,
  esSaintTmsUtah,
  esSaintTmsNevada,
  esSaintTmsColorado,
  esSaintAgeRequirements,
  // Newer English learn articles → Spanish
  esAcceleratedTmsCost,
  esAcceleratedTmsNearMe,
  esCanSaintMakeDepressionWorse,
  esCognitiveFxAlternative,
  esSaintCoralGables,
  esSaintTmsSuccessRates,
  esSaintVsMert,
  esSaintVsOneDayTms,
  esSaintVsDeepTms,
];

function findEsPageBySlug(slug: string) {
  return esPages.find((p) => p.slug === slug);
}

const ES_LEARN_SLUG_REDIRECTS: Record<string, string> = {
  "what-are-the-side-effects-of-saint-tms": "/es/learn/is-saint-tms-safe",
  // Consolidated into /es/learn/what-is-saint-tms
  "what-is-saint-treatment-for-depression": "/es/learn/what-is-saint-tms",
  "stanford-accelerated-intelligent-neuromodulation-therapy":
    "/es/learn/what-is-saint-tms",
  // Legacy short slug — redirect, never 404
  "saint-tms": "/es/learn/what-is-saint-tms",
  // Consolidated into /es/learn/how-fast-does-saint-tms-work
  "how-fast-does-saint-tms-work-compared-to-tms":
    "/es/learn/how-fast-does-saint-tms-work",
  // Consolidated into /es/learn/what-happens-between-saint-sessions
  "what-to-expect-during-saint-tms":
    "/es/learn/what-happens-between-saint-sessions",
  "how-long-does-saint-tms-treatment-take":
    "/es/learn/what-happens-between-saint-sessions",
  "saint-treatment-week-day-by-day":
    "/es/learn/what-happens-between-saint-sessions",
  // Consolidated into /es/learn/does-saint-tms-require-anesthesia
  "does-saint-tms-require-anesthesia-or-medication":
    "/es/learn/does-saint-tms-require-anesthesia",
  // Consolidated into /es/learn/can-i-drive-and-work-during-saint-tms
  "can-i-work-during-saint-tms-treatment-week":
    "/es/learn/can-i-drive-and-work-during-saint-tms",
  // Consolidated into /es/learn/outpatient-saint-tms
  "is-saint-tms-outpatient-or-hospital": "/es/learn/outpatient-saint-tms",
  // Consolidated into /es/learn/saint-tms-locations
  "saint-tms-east-coast": "/es/learn/saint-tms-locations",
  "5-day-tms-treatment": "/es/learn/saint-tms-locations",
  "saint-tms-coral-springs-south-florida": "/es/learn/saint-tms-locations",
  // Consolidated into /es/learn/does-insurance-cover-saint-tms
  "is-saint-tms-covered-by-insurance":
    "/es/learn/does-insurance-cover-saint-tms",
  // Consolidated into /es/learn/when-antidepressants-dont-work
  "what-happens-when-two-antidepressants-dont-work":
    "/es/learn/when-antidepressants-dont-work",
  "why-still-depressed-while-taking-medication":
    "/es/learn/when-antidepressants-dont-work",
  "depression-wont-go-away-even-with-medication":
    "/es/learn/when-antidepressants-dont-work",
  // Consolidated into /es/learn/tms-after-antidepressants-fail
  "can-tms-help-after-antidepressants-fail":
    "/es/learn/tms-after-antidepressants-fail",
  // Consolidated into /es/learn/can-saint-help-if-antidepressants-didnt-work
  "saint-after-medication-failure":
    "/es/learn/can-saint-help-if-antidepressants-didnt-work",
  // Consolidated into /es/learn/depression-treatment-without-medication
  "depression-treatment-without-more-medication":
    "/es/learn/depression-treatment-without-medication",
  "depression-treatment-without-another-medication":
    "/es/learn/depression-treatment-without-medication",
  "dont-want-to-keep-changing-antidepressants":
    "/es/learn/depression-treatment-without-medication",
  // Consolidated into /es/learn/nothing-works-for-my-depression
  "what-options-are-left-when-nothing-works-for-depression":
    "/es/learn/nothing-works-for-my-depression",
  "depression-feels-impossible-to-treat":
    "/es/learn/nothing-works-for-my-depression",
  "tired-of-feeling-depressed-options-left":
    "/es/learn/nothing-works-for-my-depression",
  "tired-of-feeling-depressed-options":
    "/es/learn/nothing-works-for-my-depression",
  "depressed-for-years-what-else-can-i-try":
    "/es/learn/nothing-works-for-my-depression",
  "lost-hope-after-depression-treatments":
    "/es/learn/nothing-works-for-my-depression",
  "what-comes-after-medication-and-therapy-for-depression":
    "/es/learn/nothing-works-for-my-depression",
  // Consolidated into /es/learn/why-does-my-depression-keep-coming-back
  "why-does-depression-keep-coming-back":
    "/es/learn/why-does-my-depression-keep-coming-back",
  // Consolidated into /es/learn/options-if-therapy-doesnt-help-depression
  "what-if-therapy-isnt-helping-depression":
    "/es/learn/options-if-therapy-doesnt-help-depression",
  // Consolidated into /es/learn/tms-vs-medication
  "tms-vs-medication-for-depression": "/es/learn/tms-vs-medication",
  // Consolidated into /es/learn/what-is-a-verified-saint-provider
  "questions-to-ask-a-saint-provider":
    "/es/learn/what-is-a-verified-saint-provider",
  "how-to-find-a-legitimate-saint-provider":
    "/es/learn/what-is-a-verified-saint-provider",
  // Consolidated into /es/learn/fast-depression-treatment
  "fastest-treatment-for-severe-depression":
    "/es/learn/fast-depression-treatment",
  "fast-treatment-resistant-depression-options":
    "/es/learn/fast-depression-treatment",
};

export const Route = createFileRoute("/es/learn/$slug")({
  beforeLoad: ({ params }) => {
    const target = ES_LEARN_SLUG_REDIRECTS[params.slug];
    if (target) {
      throw redirect({ to: target, statusCode: 301 });
    }
    if (!findEsPageBySlug(params.slug)) {
      throw notFound();
    }
  },
  component: RouteComponent,
  head({ params }) {
    const page = findEsPageBySlug(params.slug);
    if (!page) {
      return {
        meta: [
          { title: "Artículo no encontrado" },
          { name: "robots", content: "noindex" },
        ],
      };
    }
    const url = `${SITE_URL}${page.canonical}`;
    // Strip any existing brand suffix from the page title so we never
    // produce a doubled "… | Neuro Wellness | Neuro Wellness".
    const cleanTitle = page.title
      .replace(/\s*\|\s*Neuro Wellness.*$/i, "")
      .trim();
    const title = `${cleanTitle} | Neuro Wellness`;
    return {
      meta: [
        { title },
        { name: "description", content: page.description },
        { property: "og:title", content: title },
        { property: "og:description", content: page.description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "es_ES" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [
        { rel: "canonical", href: url },
        ...buildHreflang(`/learn/${page.slug}`),
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page.schemaJson),
        },
      ],
    };
  },
});

function RouteComponent() {
  const { slug } = useParams<{ slug: string }>();
  const page = findEsPageBySlug(slug);

  if (!page) {
    return <Navigate to="/es/learn" replace />;
  }

  // For the "still depressed on medication" article, embed the real SAINT
  // eligibility form (same form + tracking as /saint) below the intro and
  // again at the end — rendered as an actual <form>, not a link.
  let sections = page.sections;
  if (slug === "why-still-depressed-while-taking-medication") {
    const formSection = {
      heading: "",
      body: (
        <InlineEligibilityForm source="es-learn-still-depressed-eligibility" />
      ),
    };
    sections = [
      ...page.sections.slice(0, 1),
      formSection,
      ...page.sections.slice(1),
      formSection,
    ] as typeof page.sections;
  }

  return (
    <LearnPageLayoutEs
      title={page.title}
      description={page.description}
      canonical={page.canonical}
      h1={page.h1}
      breadcrumbLabel={page.breadcrumbLabel}
      crumbs={page.crumbs}
      shortAnswer={page.shortAnswer}
      keyTakeaways={page.keyTakeaways}
      sections={sections}
      faqs={page.faqs}
      sources={page.sources}
      schemaJson={page.schemaJson}
      relatedLinks={page.relatedLinks}
      reviewBlock={page.reviewBlock}
    />
  );
}
